import React, { useEffect, useState } from "react";
import "./ai-settings.css";

const AiConfiguration = ({
  userReply = false,
  onUserReplyChange,
  disabled = false,
  showCredentialHarvesting = false,
  credentialHarvesting = false,
  onCredentialHarvestingChange,
  credentialHarvestingDisabled = false,
}) => {
  const [internalUserReply, setInternalUserReply] = useState(!!userReply);
  const [internalCredentialHarvesting, setInternalCredentialHarvesting] = useState(!!credentialHarvesting);
  const currentUserReply = onUserReplyChange ? !!userReply : internalUserReply;
  const currentCredentialHarvesting = onCredentialHarvestingChange ? !!credentialHarvesting : internalCredentialHarvesting;

  useEffect(() => {
    setInternalUserReply(!!userReply);
  }, [userReply]);

  useEffect(() => {
    setInternalCredentialHarvesting(!!credentialHarvesting);
  }, [credentialHarvesting]);

  const toggleUserReply = () => {
    const next = !currentUserReply;
    if (onUserReplyChange) onUserReplyChange(next);
    else setInternalUserReply(next);
  };

  const toggleCredentialHarvesting = () => {
    const next = !currentCredentialHarvesting;
    if (onCredentialHarvestingChange) onCredentialHarvestingChange(next);
    else setInternalCredentialHarvesting(next);
  };

  return (
    <div className="ais-card">
      <p className="ais-title">Configuration:</p>
      <div className="ais-row">
        <span className="ais-label">User Reply</span>
        <span className="ais-info" title="Allow users to reply to this campaign">i</span>
        <button
          className={`ais-toggle${currentUserReply ? " on" : ""}`}
          onClick={toggleUserReply}
          aria-label="Toggle user reply"
          disabled={disabled}
        >
          <span className="ais-toggle-thumb" />
        </button>
      </div>
      {showCredentialHarvesting && (
        <div className="ais-row">
          <span className="ais-label">Credential Harvesting</span>
          <span className="ais-info" title="Track users who submit data on the landing page">i</span>
          <button
            className={`ais-toggle${currentCredentialHarvesting ? " on" : ""}`}
            onClick={toggleCredentialHarvesting}
            aria-label="Toggle credential harvesting"
            disabled={credentialHarvestingDisabled}
          >
            <span className="ais-toggle-thumb" />
          </button>
        </div>
      )}
    </div>
  );
};

export default AiConfiguration;
